import React, { useContext, useEffect } from "react";
import { AuthContext } from "../../services/AuthContext";
import { RadioContext } from "../../services/RadioProvider";
import MDotCanvas from "../MCanvas/MDotCanvas";
import "./MLogo.css";

export default function MLogo() {
    const { isLoggedIn, setUserModalOpen } = useContext(AuthContext);
    const { nowPlaying } = useContext(RadioContext);
    const { listeners } = nowPlaying

    useEffect(() => {
    }, [nowPlaying]);

    const className = isLoggedIn ? "is-logged-in" : "is-not-logged-in";
    return (
        <div className="logo-main">
            <div className="logo-img-link">
                <div className="logo-text">
                    <a  href="https://cueroom.online">
                        <img className="vip-logo" src="/images/logo.png" alt="VIP Radio Logo" />
                    </a>
                </div>
                {/* <div className="d-logo-text">
                    <a href="https://vip-radio.online">
                        <div className="d-vip">VIP-RADIO.ONLINE</div>
                        <div className="d-cool">Cool Online Music</div>
                    </a>
                </div> */}
                <button className={`user ${className}`} onClick={() => setUserModalOpen(true)}><i className="fas fa-user"></i></button>
            </div>
            <div className="logo-listeners">
                <h1>
                    <div className="m-title-listeners">
                        <div>
                            <i className="fas fa-headphones"></i>
                            <span className="m-listener-count">{listeners}</span>
                        </div>
                    </div>
                </h1>
            </div>
            <MDotCanvas></MDotCanvas>
        </div>
    );
}